// Renk paleti
export const colors = {
  primary: '#E91E63',
  secondary: '#673AB7',
  dark: '#0F0F0F',
  darker: '#050505',
  light: '#E5E7EB',
  gray: '#9CA3AF',
  white: '#FFFFFF',
  success: '#4ade80',
  warning: '#ff8e53',
  error: '#ef4444'
};

// Gradientler
export const gradients = {
  primary: `linear-gradient(135deg, #ff2d72, #E91E63)`,
  hero: `linear-gradient(45deg, ${colors.darker}, ${colors.dark})`,
  card: {
    blue: 'linear-gradient(135deg, #1e3c72, #2a5298)',
    purple: 'linear-gradient(135deg, #667eea, #764ba2)',
    orange: 'linear-gradient(135deg, #FF6B6B, #FF8E53)'
  },
  glass: {
    light: 'linear-gradient(135deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.15))',
    hover: 'linear-gradient(135deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.25))'
  }
};

// Gölgeler
export const shadows = {
  sm: '0 4px 6px rgba(0, 0, 0, 0.1)',
  md: '0 10px 20px rgba(0, 0, 0, 0.15)',
  lg: '0 20px 40px rgba(0, 0, 0, 0.2)',
  primary: '0 10px 20px rgba(233, 30, 99, 0.3)',
  secondary: '0 10px 20px rgba(139, 92, 246, 0.3)'
};

// Kenar yumuşatma
export const borderRadius = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  '2xl': '32px',
  full: '9999px'
};

// Z-index katmanları
export const zIndex = {
  hide: -1,
  base: 0,
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modal: 1040,
  popover: 1050,
  tooltip: 1060
};

// Medya sorguları
export const breakpoints = {
  xs: '480px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px'
};

// Geçiş animasyonları
export const transitions = {
  default: 'all 0.3s ease',
  fast: 'all 0.15s ease',
  slow: 'all 0.45s ease',
  bounce: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
};

// Tipografi
export const typography = {
  fonts: {
    base: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif'
  },
  weights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800
  },
  sizes: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    base: '1rem',     // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem',// 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem'     // 48px
  },
  // Tutarlı metin boyutları için kategoriler
  categories: {
    // Ana başlık boyutları
    heroTitle: {
      desktop: 'clamp(2.5rem, 5vw, 4rem)',
      tablet: 'clamp(2.2rem, 4vw, 3rem)', 
      mobile: 'clamp(1.8rem, 4vw, 2.5rem)'
    },
    // Sayfa başlık boyutları
    pageTitle: {
      desktop: '2.5rem',
      tablet: '2.2rem',
      mobile: '2rem'
    },
    // Bölüm başlık boyutları
    sectionTitle: {
      desktop: '2rem',
      tablet: '1.8rem',
      mobile: '1.6rem'
    },
    // Kart başlık boyutları
    cardTitle: {
      desktop: '1.4rem',
      tablet: '1.3rem',
      mobile: '1.2rem'
    },
    // Alt başlık boyutları
    subtitle: {
      desktop: 'clamp(1.1rem, 2vw, 1.3rem)',
      tablet: '1.2rem',
      mobile: '1.1rem'
    },
    // Açıklama metni boyutları
    description: {
      desktop: '1.2rem',
      tablet: '1.1rem',
      mobile: '1.1rem'
    },
    // Küçük açıklama metni boyutları
    smallDescription: {
      desktop: '1rem',
      tablet: '0.95rem',
      mobile: '0.9rem'
    },
    // Buton metni boyutları
    button: {
      desktop: '1rem',
      tablet: '0.95rem',
      mobile: '0.9rem'
    },
    // Etiket metni boyutları
    label: {
      desktop: '0.9rem',
      tablet: '0.85rem',
      mobile: '0.8rem'
    }
  },
  lineHeights: {
    none: 1,
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2
  }
};

// Ortak stil mixinler
export const mixins = {
  flexCenter: `
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  flexBetween: `
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  gridCenter: `
    display: grid;
    place-items: center;
  `,
  absoluteCenter: `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `,
  textGradient: (gradient = gradients.primary) => `
    background: ${gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  `,
  textNeumorphism: `
    background: linear-gradient(135deg, #ff2d72, #E91E63);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.5)) drop-shadow(-1px -1px 2px rgba(255, 255, 255, 0.1));
  `,
  glass: `
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
  `
}; 